//#region DevExtreme Imports

import 'devextreme/ui/check_box'

//#endregion

import { AlarmDefinitionGroupRowEditController } from './alarm-definition-group-row-edit.controller'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../../services/user-session'
import { ALARM_DEFINITION_SERVICE_NAME, AlarmDefinitionService } from '../../../../services/alarm-definition'

//#region Asset Imports

import './alarm-definition-group-row-edit.scss'
import * as TEMPLATE from './alarm-definition-group-row-edit.tpl.html'

//#endregion

// #region Consts

export const COMPONENT_NAME: string = 'alarmDefinitionGroupRowEdit'

// #endregion

export class AlarmDefinitionGroupRowEditComponent {

    controller = [
        ALARM_DEFINITION_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        (
            alarmDefinitionService: AlarmDefinitionService,
            userSessionService: UserSessionService
        ) => {
            return new AlarmDefinitionGroupRowEditController(alarmDefinitionService, userSessionService)
        }
    ]

    bindings = {
        options: '<',
    } as { [index: string]: string }

    template = TEMPLATE
}
